export const LAYOUTS = [
    { id: 'layout1', name: '1 Column', columns: 1, rows: 1, template: [1] },
    { id: 'layout2', name: '2 Columns', columns: 2, rows: 1, template: [1, 1] },
    { id: 'layout3', name: '3 Columns', columns: 3, rows: 1, template: [1, 1, 1] },
    { id: 'layout4', name: '4 Columns', columns: 4, rows: 1, template: [1, 1, 1, 1] },
    { id: 'layout5', name: '3/1 Columns', columns: 2, rows: 1, template: [3, 1] },
    { id: 'layout6', name: '1/3 Columns', columns: 2, rows: 1, template: [1, 3] },
    { id: 'layout7', name: '2/2 Columns', columns: 2, rows: 2, template: [1, 1, 1, 1] },
    { id: 'layout8', name: '3/3 Columns', columns: 3, rows: 2, template: [1, 1, 1, 1, 1, 1] },
    { id: 'layout9', name: 'Layout 9', columns: 2, rows: 2, template: [1, 3, 3, 1] },
    { id: 'layout10', name: 'Layout 10', columns: 2, rows: 2, template: [3, 1, 1, 3] },
    { id: 'layout11', name: 'Layout 11', columns: 2, rows: 2, template: [1, 1, 2, 1] },
    { id: 'layout12', name: 'Layout 12', columns: 2, rows: 2, template: [1, 2, 2, 1] }, 
];